"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ArrowDown = _interopRequireDefault(require("../../../../assets/images/ArrowDown.svg"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Collapse = require("./Collapse");
var _AccordionModule = _interopRequireDefault(require("./Accordion.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function addToSetImmutable(previousSet, item) {
  return new Set(previousSet).add(item);
}
function deleteFromSetImmutable(previousSet, item) {
  const nextSet = new Set(previousSet);
  nextSet.delete(item);
  return nextSet;
}
function getTotalColumnsCount(headersCount) {
  return headersCount + 1; //INFO: 1 extra column for expand control element
}
function buildCell(cellItem, cellIndex) {
  return /*#__PURE__*/_react.default.createElement("td", {
    key: cellIndex,
    className: _AccordionModule.default["td-summary"]
  }, cellItem.value);
}
function buildRow(rowItem, isExpanded, totalColumnCount, onExpandSwitch, variant) {
  const DetailsComponent = rowItem.detailsComponent;
  const isExpandable = Boolean(DetailsComponent);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
    key: rowItem.id
  }, /*#__PURE__*/_react.default.createElement("tr", {
    className: (0, _clsx.default)(_AccordionModule.default["tr-summary"], isExpandable && isExpanded(rowItem.id) ? _AccordionModule.default["expanded"] : ""),
    onClick: event => onExpandSwitch(event, rowItem.id)
  }, rowItem.columns.map((item, index) => buildCell(item, index)), /*#__PURE__*/_react.default.createElement("td", {
    key: "expand",
    className: (0, _clsx.default)(_AccordionModule.default["td-summary"], variant === "variant-2" && _AccordionModule.default["variant-2"])
  }, isExpandable && /*#__PURE__*/_react.default.createElement("img", {
    className: _AccordionModule.default["expand-control"],
    src: _ArrowDown.default,
    alt: "expand"
  }))), isExpandable && /*#__PURE__*/_react.default.createElement("tr", {
    className: _AccordionModule.default["tr-details"]
  }, /*#__PURE__*/_react.default.createElement("td", {
    className: _AccordionModule.default["td-details"],
    colSpan: totalColumnCount
  }, /*#__PURE__*/_react.default.createElement(_Collapse.Collapse, {
    open: isExpanded(rowItem.id)
  }, /*#__PURE__*/_react.default.createElement(DetailsComponent, rowItem.detailsComponentProps)))));
}
const AccordionTable = _ref => {
  let {
    tHeaders,
    rows,
    expanded,
    variant
  } = _ref;
  const [expandedIds, setExpandedIds] = (0, _react.useState)(new Set());
  const isExpanded = (0, _react.useCallback)(rowId => {
    return expandedIds.has(rowId);
  }, [expandedIds]);
  const onExpandSwitch = (0, _react.useCallback)((_, id) => {
    isExpanded(id) ? setExpandedIds(previousSet => deleteFromSetImmutable(previousSet, id)) : setExpandedIds(previousSet => addToSetImmutable(previousSet, id));
  }, [isExpanded]);
  (0, _react.useLayoutEffect)(() => {
    if (expanded) {
      setExpandedIds(new Set(rows.map(row => row.id)));
    } else {
      setExpandedIds(new Set());
    }
  }, [expanded, rows]);
  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _clsx.default)("accordion-table", _AccordionModule.default.root, _AccordionModule.default.table)
  }, /*#__PURE__*/_react.default.createElement("colgroup", null, tHeaders.map((_, index) => /*#__PURE__*/_react.default.createElement("col", {
    key: index,
    className: "column-data"
  })), /*#__PURE__*/_react.default.createElement("col", {
    className: _AccordionModule.default["column-expand-control"]
  })), /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, tHeaders.map((item, index) => /*#__PURE__*/_react.default.createElement("th", {
    className: _AccordionModule.default.th,
    key: `${index}-1`,
    style: item.sx
  }, item.name)), /*#__PURE__*/_react.default.createElement("th", {
    key: "expand",
    className: _AccordionModule.default.th
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, rows.map(item => buildRow(item, isExpanded, getTotalColumnsCount(tHeaders.length), onExpandSwitch, variant))));
};
AccordionTable.propTypes = {
  // type: PropTypes.oneOf(["error", "success", "warning", "info"]),
  // message: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};
var _default = exports.default = AccordionTable;